module.exports = __webpack_public_path__ + "img/Oberperfuss2.2ff3639b.jpg";